import React, { useRef, useState, useEffect } from "react";
import i18n from "i18next";
import { IUserDocument } from "../../Models/IUserDocument";
import {
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Divider,
  MessageBar,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { IDokument } from "../../Models/IDokument";

interface IProductDocumentsListProps {
  title: string;
  items: IDokument[] | IUserDocument[];
  columns: TableColumnDefinition<IDokument | IUserDocument>[];
}

function ProductDocumentsList(props: IProductDocumentsListProps) {
  const { title, items, columns } = props;
  return (
    <div>
      <Divider appearance="brand">{title}</Divider>
      <div className="lueb-InnerContentBlockPadding2px">
        <div style={{ padding: 5, overflow: "auto" }}>
          <DataGrid
            items={items}
            columns={columns}
            resizableColumns={true}
            columnSizingOptions={{
              docFileExtension: {
                minWidth: 40,
                defaultWidth: 40,
              },
              artikelId: {
                minWidth: 110,
                defaultWidth: 110,
              },
              auftragId: {
                minWidth: 110,
                defaultWidth: 110,
              },
              productId: {
                minWidth: 110,
                defaultWidth: 110,
              },
              benennung: {
                minWidth: 190,
                defaultWidth: 500,
              },
              actions: {
                minWidth: 90,
                defaultWidth: 90,
              },
            }}
          >
            <DataGridHeader>
              <DataGridRow>
                {({ renderHeaderCell }) => (
                  <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                )}
              </DataGridRow>
            </DataGridHeader>
            <DataGridBody<IDokument | IUserDocument>>
              {({ item, rowId }) => (
                <DataGridRow<any> key={rowId}>
                  {({ renderCell }) => (
                    <DataGridCell>{renderCell(item)}</DataGridCell>
                  )}
                </DataGridRow>
              )}
            </DataGridBody>
          </DataGrid>

          {items.length == 0 && (
            <MessageBar style={{ marginTop: "5px" }} intent="info">
              {i18n.t<string>("noItemsFound")}
            </MessageBar>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductDocumentsList;
